import React from 'react';
import styles from './Button.module.scss';

export type ButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'size'> & {
    text?: string;
    error?: string;
    className?: string;
};

export function Button({
    text,
    className,
    type,
    ...rest
}: ButtonProps) {
    return (
        <button className={[styles.button, className].filter(Boolean).join(' ')} {...rest} type={type ? type : "button"}>{text}</button>
    );
}

export default Button;
